import ImgNotFound from '../../assets/imgs/pagina_nao_encontrada.svg';
import { Typography } from '../../components/tailwind';

const classes = {
    image: {
        marginTop: 300,
        display: 'inline-block',
        maxWidth: '100%',
        width: 660,
    },
};

const Desenvolvimento = () => {
    return (
        <div
            style={{
                paddingTop: 80,
                textAlign: 'center',
                width: '100%',
            }}
        >
            <div className='w-full flex flex-col items-center'>
                <div className='w-full'>
                    <Typography variant="h1">Acesso não autorizado</Typography>
                    <Typography variant="h5"><a href="/">Voltar ao início</a></Typography>
                </div>
            </div>
        </div>
    );
};

export default Desenvolvimento;